const PaymentMode = {
  HF: 'HF',
  HP: 'HP',
  HPage: 'HPage'
};

export default PaymentMode;
